module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-container"
  }, [_c('el-row', {
    staticClass: "headTop"
  }, [_c('el-col', {
    attrs: {
      "span": 2,
      "offset": 22
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "success",
      "icon": "el-icon-circle-plus-outline"
    },
    on: {
      "click": function($event) {
        return _vm.showDialog()
      }
    }
  }, [_vm._v("新增")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "赛事管理",
      "visible": _vm.dialogVisible,
      "width": "1000px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "formparams",
    attrs: {
      "model": _vm.formparams,
      "rules": _vm.rules,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "分店",
      "prop": "shopNum"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.formparams.shopNum),
      callback: function($$v) {
        _vm.$set(_vm.formparams, "shopNum", $$v)
      },
      expression: "formparams.shopNum"
    }
  }, _vm._l((this.shopList), function(item) {
    return _c('el-option', {
      key: item.shopNum,
      attrs: {
        "label": item.name,
        "value": item.shopNum
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "赛事标题",
      "prop": "title"
    }
  }, [_c('el-input', {
    staticClass: "w220",
    attrs: {
      "placeholder": "请输入赛事标题"
    },
    model: {
      value: (_vm.formparams.title),
      callback: function($$v) {
        _vm.$set(_vm.formparams, "title", $$v)
      },
      expression: "formparams.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "报名时间",
      "prop": "date"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetimerange",
      "value-format": "yyyy-MM-dd HH:mm:ss",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期"
    },
    model: {
      value: (_vm.date2),
      callback: function($$v) {
        _vm.date2 = $$v
      },
      expression: "date2"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动时间",
      "prop": "date"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetimerange",
      "value-format": "yyyy-MM-dd HH:mm:ss",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期"
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "最大队伍数量",
      "prop": "teamNumber"
    }
  }, [_c('el-input', {
    staticClass: "w220",
    attrs: {
      "placeholder": "请输入最大队伍数量"
    },
    model: {
      value: (_vm.formparams.teamNumber),
      callback: function($$v) {
        _vm.$set(_vm.formparams, "teamNumber", _vm._n($$v))
      },
      expression: "formparams.teamNumber"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "每队最大成员",
      "prop": "teamPeopleNumber"
    }
  }, [_c('el-input', {
    staticClass: "w220",
    attrs: {
      "placeholder": "请输入每队最大成员"
    },
    model: {
      value: (_vm.formparams.teamPeopleNumber),
      callback: function($$v) {
        _vm.$set(_vm.formparams, "teamPeopleNumber", _vm._n($$v))
      },
      expression: "formparams.teamPeopleNumber"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    ref: "uploadElement",
    attrs: {
      "label": "宣传海报",
      "required": "",
      "prop": ""
    }
  }, [_c('el-upload', {
    ref: "upload",
    class: {
      uploaderNone: _vm.hideUpload
    },
    attrs: {
      "action": "aa",
      "list-type": "picture-card",
      "auto-upload": false,
      "http-request": _vm.uploadFile,
      "file-list": _vm.fileList,
      "multiple": "",
      "limit": 1,
      "on-change": _vm.onChange,
      "on-remove": _vm.handleRemove,
      "accept": "image/png,image/gif,image/jpg,image/jpeg"
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })]), _vm._v("\n          *提示*：为了更好的用户体验，图片请提供230*230像素，文件大小不超过500kb。\n        ")], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "上/下线",
      "required": ""
    }
  }, [_c('el-switch', {
    attrs: {
      "active-text": "上线",
      "inactive-text": "下线"
    },
    model: {
      value: (_vm.formparams.status),
      callback: function($$v) {
        _vm.$set(_vm.formparams, "status", $$v)
      },
      expression: "formparams.status"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "赛事说明",
      "prop": "info"
    }
  }, [_c('editor-bar', {
    attrs: {
      "isClear": _vm.isClear
    },
    model: {
      value: (_vm.formparams.info),
      callback: function($$v) {
        _vm.$set(_vm.formparams, "info", $$v)
      },
      expression: "formparams.info"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticStyle: {
      "width": "100px"
    },
    on: {
      "click": function($event) {
        return _vm.resetForm('formparams')
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('formparams')
      }
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "tableList"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.tableData,
      "height": "73vh",
      "border": "",
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "type": "index",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "title",
      "label": "赛事名称",
      "width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "宣传海报",
      "width": "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticClass: "imgList",
          staticStyle: {
            "width": "120px",
            "height": "60px"
          },
          attrs: {
            "src": 'http://zlesp.zlydgy.cn:8091/images/' + scope.row.imgurl,
            "alt": ""
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "registstarttime",
      "label": "报名开始时间"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "registendtime",
      "label": "报名结束时间"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "releasetime",
      "label": "活动开始时间"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "endtime",
      "label": "活动结束时间"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "teamnumber",
      "label": "最大队伍数",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "teampeoplenumber",
      "label": "每队人数",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "分店名称",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_vm._v(" " + _vm._s(_vm._f("caseType")(scope.row.shopNum)) + " ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == '1') ? _c('div', [_vm._v("上线")]) : _vm._e(), _vm._v(" "), (scope.row.status == '0') ? _c('div', [_vm._v("下线")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "300",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.state == 0) ? _c('el-button', {
          attrs: {
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.edit(scope.row)
            }
          }
        }, [_vm._v("编辑")]) : _vm._e(), _vm._v(" "), (scope.row.state == 2) ? _c('el-button', {
          attrs: {
            "type": "info"
          }
        }, [_vm._v("已过期")]) : _vm._e(), _vm._v(" "), (scope.row.status == '0' && scope.row.state != 2) ? _c('el-button', {
          attrs: {
            "type": "success"
          },
          on: {
            "click": function($event) {
              return _vm.changeStatus(scope.row)
            }
          }
        }, [_vm._v("上线")]) : _vm._e(), _vm._v(" "), (scope.row.status == '1' && scope.row.state != 2) ? _c('el-button', {
          attrs: {
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.changeStatus(scope.row)
            }
          }
        }, [_vm._v("下线")]) : _vm._e(), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "warning"
          },
          on: {
            "click": function($event) {
              return _vm.gositeListInfo(scope.row)
            }
          }
        }, [_vm._v("团队详情")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "pageination",
    staticStyle: {
      "display": "none"
    }
  }, [_c('el-col', [_c('el-pagination', {
    staticStyle: {
      "textAlign": "center",
      "marginTop": "10px"
    },
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [20, 40, 80, 100],
      "page-size": 20,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": this.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      },
      "update:current-page": function($event) {
        _vm.currentPage = $event
      }
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-1751ce01"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/gameModule/gameList.vue
// module id = 590
// module chunks = 70